<script setup lang="ts">
import { useTeamSides } from '@desktop/views/Relation/composables'

import PitchIncidentsSeparator from '../PitchIncidents/PitchIncidentsSeparator.vue'
import PitchParticipantWithIncidents from './PitchParticipantWithIncidents/PitchParticipantWithIncidents.vue'

// composables
const { getParticipantsWithCurrentTeamSides } = useTeamSides()
const { currentFirstParticipant, currentSecondParticipant } =
  getParticipantsWithCurrentTeamSides()
</script>

<template>
  <div class="grid flex-1 grid-cols-[1fr_auto_1fr]">
    <PitchParticipantWithIncidents
      v-if="currentFirstParticipant"
      :participant="currentFirstParticipant"
    />
    <PitchIncidentsSeparator />
    <PitchParticipantWithIncidents
      v-if="currentSecondParticipant"
      :participant="currentSecondParticipant"
      reversed
    />
  </div>
</template>
